import React from 'react';
import SIdebar from './SIdebar';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useLocation } from 'react-router-dom';


const Sobre = () => {
  const location = useLocation()
    AOS.init({
      duration: 2000,
    });
    return (
      <div>
        <SIdebar local={location.pathname}/>
        <div className='w3-tag w3-teal sobre' style={{padding: '20px', borderRadius: '3px'}} data-aos="fade-down" >
          <h1>Oi, meu nome é Reinaldo Pereira dos Santos</h1>
          <p>
            Engenheiro de Software com ênfase em Desenvolvimento Web, Tecnólogo em análise e desenvolvimento de sistemas e  graduado recentemente pela Trybe e com sólida formação acadêmica na área, inicialmente pela UFGD e posteriormente pela Unicesumar, onde concluí minha graduação em Engenharia de Software em 2021. Sou um profissional proativo, dotado de pensamento crítico e analítico, apaixonado por tecnologia e sempre em busca de atualizações sobre as últimas tendências de mercado.

            Tenho experiência e habilidades robustas em diversas tecnologias, destacando-me em competências como React.js, Angular +15, NodeJs, HTML, CSS, Jest, Linux, Desenvolvimento Orientado a Testes, API REST, TypeScript, JSON Web Token (JWT), Node.js, MySQL, SQL, Docker, React Hooks, Redux.js, GitHub, Git, JavaScript, HTML5, Python, Java e MongoDB. Essas competências, aliadas a uma sólida compreensão de metodologias ágeis de desenvolvimento de software, refletem meu comprometimento com a entrega de soluções eficientes e de alta qualidade.

            Minha trajetória acadêmica e profissional reforça minha dedicação à programação e à constante busca por excelência. Além disso, mantenho um perfil ativo no <a href="https://github.com/reinaldoper">Git hub</a>, onde compartilho e colaboro em projetos, demonstrando meu comprometimento com o aprendizado contínuo e a comunidade de desenvolvedores.

            Além das habilidades técnicas, possuo proficiência em inglês técnico para leitura e conhecimentos básicos de espanhol. Nas horas vagas, priorizo o convívio familiar, ressaltando a importância do equilíbrio entre vida pessoal e profissional.

            Acredito firmemente no poder transformador da programação e no impacto positivo que ela pode ter na vida das pessoas. Estou entusiasmado para contribuir com projetos desafiadores, agregar valor e continuar crescendo profissionalmente em um ambiente dinâmico e inovador.
            Meu <a href="https://reinaldoper.github.io/cv/">CV-ONLINE.</a>
          </p>
        </div>
      </div>
    )
  
}

export default Sobre;
